import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import parse from 'react-html-parser';
import format from 'string-template';

import { CoachInfo as CoachInfoModel } from '../../../../../../../../Model/CoachInfo';
import Coach from '../../../../../../../../Model/Coach';
import InternalAssignment from '../../../../../../../../Model/InternalAssignment';
import { AssignmentRole } from '../../../../../../../../utils/internalAssignments';
import useComponentMounted from '../../../../../../../../hooks/useComponentMounted';
import {
  ModalContent,
  SubTitle,
} from '../../styles';

import StructuredCoachInfoView from './StructuredCoachInfoView';
import {
  InfoSection,
  InfoContainer,
  StyledLoadingPage,
} from './styles';
import texts from './texts.json';

const CoachDetails = ({ coachId }) => {
  const [coachInfo, setCoachInfo] = useState();
  const [isNewCoachInfoView, setIsNewCoachInfoView] = useState(false);
  const [assignedCAMName, setAssignedCAMName] = useState('');
  const [isEnrolledAt, setIsEnrolledAt] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const isComponentMountedRef = useComponentMounted();

  useEffect(() => {
    const loadCoachInfo = async () => {
      setIsLoading(true);
      const [coachInfoCollection, camInternalAssignment, coachDoc] = await Promise.all([
        CoachInfoModel.getCoachInfosByCoachId(coachId),
        InternalAssignment.getCurrentAssignmentOfCoachByRole(coachId, AssignmentRole.CAM),
        Coach.getCoachById(coachId),
      ]);
      const currentCoachInfo = coachInfoCollection.docs.find((doc) => doc.current);

      if (isComponentMountedRef.current) {
        setIsEnrolledAt(coachDoc.isEnrolledAt);
        if (camInternalAssignment.hasDocs) {
          setAssignedCAMName(camInternalAssignment.docs[0].userName);
        }
        if (currentCoachInfo) {
          setCoachInfo(currentCoachInfo);
          setIsNewCoachInfoView(true);
        } else if (!coachInfoCollection.hasDocs) {
          setCoachInfo(format(texts.coachName, { coachName: coachDoc.name }));
        } else {
          setCoachInfo(coachInfoCollection.docs[0]?.coachInfoNote
            || format(texts.coachName, { coachName: coachDoc.name }));
        }
      }
      setIsLoading(false);
    };

    loadCoachInfo();
  }, [coachId, isComponentMountedRef]);

  if (isLoading) {
    return <StyledLoadingPage />;
  }

  return (
    <ModalContent>
      <SubTitle>{texts.coachDetails}</SubTitle>
      {isNewCoachInfoView ? (
        <StructuredCoachInfoView
          data={coachInfo}
          assignedCAMName={assignedCAMName}
          isEnrolledAt={isEnrolledAt?.toDate()}
        />
      ) : (
        <InfoSection>
          <InfoContainer>
            {parse(coachInfo)}
          </InfoContainer>
        </InfoSection>
      )}
    </ModalContent>
  );
};

CoachDetails.propTypes = {
  coachId: PropTypes.string.isRequired,
};

export default CoachDetails;
